export default "__VITE_ASSET__B_KD6TPa__"